module.exports = __webpack_public_path__ + "img/haihengbg.f9eefead.png";